import {
  FieldText,
  FlexBox,
  FormField,
  FormGrid,
  IconButton,
} from '@dixa/lib-shared-habla';
import { Field } from 'redux-form';

import { Route } from 'components/settings/components/sections/dixaMessenger/views/flow/flow.types';
import { FieldRepeaterRowProps } from 'fable/fieldRepeater/fieldRepeater';

type Props = FieldRepeaterRowProps<Route>;

export const FieldRoutes = ({
  field,
  index,
  totalRows,
  onRemove,
}: Props): JSX.Element => {
  return (
    <FlexBox>
      <FormGrid>
        <FormField span={6}>
          <Field
            component={FieldText}
            name={`${field}.urlPrefix`}
            label={`URL #${index + 1}`}
            placeholder="E.g. https://www.yoursite.com"
          />
          <Field component="input" type="hidden" name={`${field}.nextNodeId`} />
        </FormField>
      </FormGrid>
      <FlexBox alignItems="center" margin="0 0 0 300">
        <IconButton
          icon="trash"
          variant="tertiary"
          type="button"
          disabled={totalRows === 1}
          onClick={() => onRemove(index)}
        />
      </FlexBox>
    </FlexBox>
  );
};
